module.exports = __webpack_public_path__ + "selfie.ec83ee72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile/selfie.png
// module id = 2494
// module chunks = 0